import {LogLevel} from '../../log-level';

/**
 * Log message styles for modern browsers.
 */
export const ConsoleAppenderColors: {[logLevel in LogLevel]: string} = {
  [LogLevel.Critical]: 'color: red; font-size: large; background-color: #fff0f0',
  [LogLevel.Error]: 'color: red; background-color: #fff0f0',
  [LogLevel.Warn]: 'color: #e87a20;',
  [LogLevel.Info]: '',
  [LogLevel.Debug]: 'color: gray;',
};
